import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa-ul"
}
const _hoisted_2 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'FontAwesomeListElement',
  props: {
  icon: {
    type: String,
    default: () => 'fa-regular fa-chevron-right',
  },
  items: Array,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.items.length)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, inx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `list-item-${inx}`,
            innerHTML: `
          <span class='fa-li'><i class='${__props.icon} text-secondary'></i></span>
          ${item}
        `
          }, null, 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})